module.exports = __webpack_public_path__ + "img/ihrm1.0a1ae1eb.png";